// @flow

import * as React from 'react';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import * as CardSizes from 'app/constants/friendCardSizes';
import GridLayout from 'app/components/layout/GridLayout';
import GridLayoutItem from 'app/components/layout/GridLayoutItem';
import ResponsiveMulti from 'app/components/responsive/ResponsiveMulti';

type Props = {
  selectedUserId?: string | number,
  children?: any,
  shortWidth?: boolean
};

const CardPoints = {
  [CardSizes.COMPACT]: { x: 1, y: 1 },
  [CardSizes.REGULAR]: { x: 3, y: 3 },
  [CardSizes.TABLET]: { x: 2, y: 2 },
  [CardSizes.TABLETPORTRAIT]: { x: 3, y: 3 }
};

const CardRatios = {
  mobile: { h: 1, w: 1 },
  desktop: { h: 1, w: 1 }
};

const defaultProps = {
  selectedUserId: undefined,
  children: [],
  shortWidth: false
};

function FriendsCardList(props: Props) {
  const { children, selectedUserId, shortWidth } = props;

  const getCardSize = (
    friendId: number,
    matches: { mobile: boolean, tabletLandscape: boolean, tabletPortrait: boolean }
  ) => {
    if (matches.mobile) {
      // mobile always shows compact becuase it'll use the slider version
      return CardSizes.COMPACT;
    }
    if (selectedUserId === friendId) {
      if (matches.tabletLandscape) {
        return CardSizes.TABLET;
      }
      if (matches.tabletPortrait) {
        return CardSizes.TABLETPORTRAIT;
      }
      return CardSizes.REGULAR;
    }
    return CardSizes.COMPACT;
  };

  const cards = React.Children.toArray(children);

  return (
    <ResponsiveMulti>
      {matches => {
        let columns = shortWidth ? 5 : 7;
        if (matches.tabletPortrait) {
          columns = 4;
        }
        if (matches.mobile) {
          columns = 3;
        }

        return (
          <GridLayout
            ratio={
              CardRatios[
                matches.mobile || matches.tabletPortrait || matches.tabletLandscape
                  ? 'mobile'
                  : 'desktop'
              ]
            }
            columns={columns}
            onEnter={Enter.appear(0.3, 0.3)}
            onLeave={Leave.disappear(0.3)}
            gutter={matches.mobile ? 10 : 20}
          >
            {cards.map(card => {
              const size = getCardSize(card.props.friend.id, matches);
              const cloneProps = {
                ...card.props,
                size
              };
              const { x, y } = CardPoints[size];
              return (
                <GridLayoutItem key={card.key} width={x} height={y}>
                  {React.cloneElement(card, cloneProps)}
                </GridLayoutItem>
              );
            })}
          </GridLayout>
        );
      }}
    </ResponsiveMulti>
  );
}

FriendsCardList.defaultProps = defaultProps;

export default FriendsCardList;
